import { DataLayer } from '@piwikpro/react-piwik-pro';

import { graphql } from 'gatsby';

import { Grid2 as Grid } from '@mui/material';

import { ResponsiveGrid, ShortTextTeaser } from '@mewa/ui';

import { PossibleContentSections } from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';

export const ShortTextTeaserFragment = graphql`
  fragment ShortTextTeaserFragment on STRAPI__COMPONENT_SHARED_SHORT_TEXT_TEASER {
    strapi_component
    headline
    subline
    labelCta
    linkUrlCta
    piwikEventNameCta
  }
`;

export const componentName = 'shared.short-text-teaser';

export type ShortTextTeaserData = {
  headline: string;
  subline: string;
  labelCta: string;
  linkUrlCta: string;
  piwikEventNameCta: string;
  strapi_component: typeof componentName;
};

export type ShortTextTeaserPreview = ShortTextTeaserData;

export const isShortTextTeaser = (
  component: PossibleContentSections,
): component is ShortTextTeaserData => {
  return component.strapi_component === componentName;
};

export const StrapiShortTextTeaser = (data: ShortTextTeaserData) => {
  return (
    <ResponsiveGrid>
      <Grid size={{ xs: 12, sm: 10, md: 6 }} offset={{ xs: 0, sm: 1, md: 3 }}>
        <ShortTextTeaser
          headline={data.headline}
          subline={data.subline}
          link={{
            component: 'a',
            label: data.labelCta,
            props: {
              href: data.linkUrlCta,
              onClick: () => {
                if (data.piwikEventNameCta) {
                  DataLayer.push({ event: data.piwikEventNameCta });
                }
              },
            },
          }}
        />
      </Grid>
    </ResponsiveGrid>
  );
};

export const config = {
  isComponent: isShortTextTeaser,
  Component: StrapiShortTextTeaser,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  componentName,
  populationParams: {},
  mapProperties: (shortTextTeaser): ShortTextTeaserData | null =>
    shortTextTeaser.strapi_component === componentName ? shortTextTeaser : null,
};
